// AI Search Banner - Adds a small indicator to show AI Search is active
(function() {
  'use strict';
  
  function addAISearchBanner() {
    // Broader search for any search-related elements
    const searchSelectors = [
      // Search icons
      '.header__search-icon',
      '.search-icon',
      '.icon-search',
      '[data-search-toggle]',
      '.search-toggle',
      '.header__icon--search',
      '.site-header__search-toggle',
      // Search inputs and forms
      'input[type="search"]',
      'input[name="q"]',
      '.search-input',
      '.predictive-search',
      '.search-form',
      '.search-bar',
      '[data-predictive-search]',
      '.header__search',
      // Generic selectors
      'button[aria-label*="search" i]',
      'a[href*="search"]',
      '.header .icon-search',
      '.header [class*="search"]',
      '.header svg[class*="search"]',
      '.header [class*="icon"][class*="search"]'
    ];
    
    let searchElement = null;
    
    // Find any search element
    for (const selector of searchSelectors) {
      searchElement = document.querySelector(selector);
      if (searchElement) {
        console.log('Found search element:', selector, searchElement);
        break;
      }
    }
    
    // If no specific element found, try to find any element with 'search' in class or data attributes
    if (!searchElement) {
      const allElements = document.querySelectorAll('*');
      for (const el of allElements) {
        const className = el.className || '';
        const dataAttrs = Array.from(el.attributes).map(attr => attr.name).join(' ');
        if (className.includes('search') || dataAttrs.includes('search')) {
          searchElement = el;
          console.log('Found search element by attribute:', el);
          break;
        }
      }
    }
    
    if (!searchElement) {
      console.log('No search element found');
      return;
    }
    
    // Check if banner already exists
    if (document.querySelector('.ai-search-banner')) return;
    
    // Create the AI banner
    const banner = document.createElement('div');
    banner.className = 'ai-search-banner';
    banner.innerHTML = '<span>AI</span>';
    banner.title = 'AI-Powered Search Active';
    
    // Add styles
    const styles = `
      .ai-search-banner {
        position: absolute;
        top: 10px;
        right: -5px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        font-size: 9px;
        font-weight: bold;
        padding: 2px 4px;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.3);
        z-index: 9999;
        pointer-events: none;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        letter-spacing: 0.3px;
      }
      
      .ai-search-banner span {
        display: block;
        line-height: 1.1;
      }
      
      @media (max-width: 768px) {
        .ai-search-banner {
          font-size: 8px;
          padding: 1px 3px;
        }
      }
    `;
    
    // Add styles to head
    if (!document.querySelector('#ai-search-banner-styles')) {
      const styleSheet = document.createElement('style');
      styleSheet.id = 'ai-search-banner-styles';
      styleSheet.textContent = styles;
      document.head.appendChild(styleSheet);
    }
    
    // Position the banner
    const container = searchElement.parentElement || searchElement;
    container.style.position = 'relative';
    container.appendChild(banner);
    
    console.log('AI banner added to:', container);
  }
  
  // Try multiple times
  function tryAddBanner() {
    addAISearchBanner();
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryAddBanner);
  } else {
    tryAddBanner();
  }
  
  // Try multiple times for dynamic content
  setTimeout(tryAddBanner, 500);
  setTimeout(tryAddBanner, 1500);
  setTimeout(tryAddBanner, 3000);
  
})();